import BaseForm from '../base';
import { LatLongColumnsComponent } from '../components';
export class ToptechForm extends BaseForm {
    constructor(...args) {
        super(...args);
        this.components = [
            new LatLongColumnsComponent({ validate: { required: true } }),
        ];
    }
}
